import { IcebergRestCatalogAuthType } from '@repo/api-gw-sdk';

import type { AddConnectorWizardState } from '@/app/(dashboard)/lakehouse/connectors/wizard/addConnectorWizardState';

type ConnectorSource =
  | { mode: 'existing'; connectorId: string }
  | {
      mode: 'new';
      connectorState: AddConnectorWizardState;
      createdConnectorId?: string;
    };

export interface AddCatalogWizardState {
  workspaceId: string;
  workspaceRegion: string | null;
  catalogType:
    | 'GLUE_CATALOG'
    | 'BIGLAKE_CATALOG'
    | 'ICEBERG_REST_CATALOG'
    | null;
  connectorSource: ConnectorSource | null;
  catalogName: string;
  region: string;
  connectorExternalId: string;
  biglakeCatalogId: string;
  biglakeLocation: string;
  icebergUri: string;
  icebergWarehouse: string;
  icebergAuthType: IcebergRestCatalogAuthType;
  icebergCredentialsSecretArn: string;
}

export const createDefaultState = (
  workspaceId: string,
  workspaceRegion: string | null
): AddCatalogWizardState => ({
  workspaceId,
  workspaceRegion,
  catalogType: null,
  connectorSource: null,
  catalogName: '',
  region: workspaceRegion ?? '',
  connectorExternalId: '',
  biglakeCatalogId: '',
  biglakeLocation: '',
  icebergUri: '',
  icebergWarehouse: '',
  icebergAuthType:
    IcebergRestCatalogAuthType.ICEBERG_REST_CATALOG_AUTH_TYPE_NONE,
  icebergCredentialsSecretArn: '',
});
